import { render, staticRenderFns } from "./AppearanceView.vue?vue&type=template&id=3b1a89e3&"
import script from "./AppearanceView.vue?vue&type=script&lang=js&"
export * from "./AppearanceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
installComponents(component, {
  VContainer,
})
